import { useEffect, useState } from "react";
import { config } from "./config";

// 公開規約（GET /policies/:kind）の最小クライアント（tst-bak0.1.31）。
// guide-web が要るのは版だけ — 契約書 全25条の本文は文書ストア未整備で台帳にも無く、
// G-02 が見せているのは主要条項の要約（config.ts contractDoc.keyTerms）。
// 版だけでも台帳から取る意味はある: 以前は contractDoc.version = "2026.05" が
// consent_log.document_version へそのまま流れ込み、台帳の版と一致する保証が無かった。

export type GuideContractVersion = { version: string; title: string; effectiveAt: string | null };

type State =
  | { status: "loading" }
  | { status: "error" }
  | { status: "ready"; policy: GuideContractVersion };

export function useGuideContractVersion(): State {
  const [state, setState] = useState<State>({ status: "loading" });
  useEffect(() => {
    const ctrl = new AbortController();
    fetch(`${config.apiBaseUrl}/policies/guide_contract`, { signal: ctrl.signal })
      .then(async (res) => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return (await res.json()) as GuideContractVersion;
      })
      .then((policy) => setState({ status: "ready", policy }))
      .catch((e: unknown) => {
        if (ctrl.signal.aborted) return;
        console.error("[policy] guide contract version load failed", e);
        setState({ status: "error" });
      });
    return () => ctrl.abort();
  }, []);
  return state;
}
